module.exports = __webpack_public_path__ + "customer-hero-desktop.4a4b42b676be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/customer-hero-desktop.jpg
// module id = ./src/styles/marketing/home/customer-hero-desktop.jpg
// module chunks = 21